import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Auth from './Auth';

export const PrivateRoute = ({ component: Component, setLoading, clientSelected, setClientSelected, ...rest }) => {

    const isLogin = Auth.isLogin();

    return (
        <Route {...rest} render={props => {
            return (
                isLogin ? <Component {...props} setLoading={setLoading} clientSelected={clientSelected} setClientSelected={setClientSelected} />
                    : <Redirect to='/login' />
            )
        }}
        />
    )
}

export const PublicRoute = ({ component: Component, setLoading, restricted, ...rest }) => {
    const isLogin = Auth.isLogin();
    return (
        // restricted = false meaning public route
        // restricted = true meaning restricted route
        <Route {...rest} render={props => (
            isLogin && restricted ?
                <Redirect to="/" />
                : <Component {...props} setLoading={setLoading} />
        )} />
    );
};
